import { useSessionStore } from '@/store/session'
import { Consumer, createConsumer } from '@rails/actioncable'

let consumer: Consumer | null = null
let lastToken: string | null = null

function buildCableUrl(): string {
  const base = import.meta.env.VITE_API_URL ?? ''
  const wsBase = base.replace(/^https?/, (m) => (m === 'https' ? 'wss' : 'ws'))
  const wsUrl = wsBase || 'ws://0.0.0.0:8000'
  const path = wsUrl.replace(/\/$/, '') + '/cable'
  const token = useSessionStore().token ?? ''
  return token ? `${path}?token=${encodeURIComponent(token)}` : path
}

export const getActionCableConsumer = (): Consumer => {
  if (typeof window === 'undefined') {
    throw new Error('ActionCable só pode ser usado no browser (não em SSR).')
  }

  const sessionStore = useSessionStore()
  const token = sessionStore.token ?? ''

  // Reutiliza o consumer existente (evita várias conexões WebSocket para a mesma sessão)
  if (consumer) {
    if (lastToken === token) return consumer
    consumer.disconnect()
    consumer = null
    lastToken = null
  }

  const cableUrl = buildCableUrl()
  consumer = createConsumer(cableUrl)
  lastToken = token
  return consumer
}

export const disconnectActionCable = () => {
  if (consumer) {
    consumer.disconnect()
    consumer = null
    lastToken = null
  }
}
